/** The Deep set: the successor's caves, A-P and the intermissions Q-T (docs/spec/03 §3). */

import type { CaveSet } from '../types';
import { deepA } from './a';
import { deepB } from './b';
import { deepC } from './c';
import { deepD } from './d';
import { deepE } from './e';
import { deepF } from './f';
import { deepG } from './g';
import { deepH } from './h';
import { deepI } from './i';
import { deepJ } from './j';
import { deepK } from './k';
import { deepL } from './l';
import { deepM } from './m';
import { deepN } from './n';
import { deepO } from './o';
import { deepP } from './p';
import { deepQ } from './q';
import { deepR } from './r';
import { deepS } from './s';
import { deepT } from './t';

export const DEEP: CaveSet = {
  id: 'deep',
  name: 'THE DEEP',
  caves: [
    deepA, deepB, deepC, deepD, deepE, deepF, deepG, deepH, deepI, deepJ,
    deepK, deepL, deepM, deepN, deepO, deepP, deepQ, deepR, deepS, deepT,
  ],
};
